import { motion } from 'framer-motion';
import { Check } from '@/components/ui/Icons';
import { company } from '@/data/company';

export function GuaranteeStrip() {
  return (
    <section className="relative bg-paper-0 py-12">
      <div className="container-page">
        <ul className="grid gap-3 sm:grid-cols-3 lg:grid-cols-5">
          {company.guarantees.map((g, i) => (
            <motion.li
              key={g}
              initial={{ opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: 0.05 * i, ease: [0.22, 1, 0.36, 1] }}
              className="flex items-center gap-3 rounded-lg border border-paper-100 bg-linear-to-br from-paper-50 to-paper-0 px-4 py-3.5 text-sm font-semibold text-navy-800 transition hover:-translate-y-0.5 hover:border-gold-300/60 hover:shadow-card"
            >
              <span className="grid h-8 w-8 flex-none place-items-center rounded-full bg-gold-400/15 text-gold-700">
                <Check className="h-4 w-4" />
              </span>
              <span>{g}</span>
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
}
